import { motion } from 'framer-motion'
import { useSlideCopy } from '@/lib/i18n'
import type { SlideProps } from '@/components/SlideWizard'
import { copy } from './Slide5LockAccounts.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide5LockAccounts(_props: SlideProps) {
  const c = useSlideCopy(copy)

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-3xl">
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1, ease }}
        className="text-xs sm:text-sm uppercase tracking-[0.25em] text-slate-400 font-semibold"
      >
        {c.eyebrow}
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.25, ease }}
        className="mt-4 text-4xl sm:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1]"
      >
        {c.title}
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.55, ease }}
        className="mt-8 text-xl sm:text-2xl text-slate-500 leading-relaxed max-w-2xl"
      >
        {c.body}
      </motion.p>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.85, ease }}
        className="mt-10 w-full max-w-lg text-start"
      >
        {c.actions.map((action, i) => (
          <motion.div
            key={action.title}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.95 + i * 0.15, ease }}
            className="py-3"
          >
            <p className="text-lg sm:text-xl font-semibold text-slate-900 leading-snug">
              <span className="tabular-nums">{i + 1}. </span>
              {action.title}
            </p>
            <p className="mt-1 text-base text-slate-500 leading-relaxed">
              {action.detail}
            </p>
          </motion.div>
        ))}
      </motion.div>

    </div>
  )
}
